var Magic8BallPage = {
    answerShown: false,
    currentCategory: 'original',
    answerLoading: false,

    init: function () {
        this.initCategoriesInputs();
        this.initQuestionForm();
        this.initQuestionsClicks();
    },

    initCategoriesInputs: function () {
        const categoryInputs = document.getElementsByClassName('category-input');
        for (const categoryInput of categoryInputs) {
            categoryInput.addEventListener('change', (event) => {
                this.hideAnswer();

                const category = event.target.value;
                const video = document.getElementById('ball_video');

                const newVideo = document.createElement('video');
                newVideo.id = video.id;
                newVideo.poster = video.poster;
                newVideo.width = video.width;
                newVideo.height = video.height;
                newVideo.preload = true;
                newVideo.disablePictureInPicture = true;
                newVideo.playsInline = true;
                newVideo.disableRemotePlayback = true;

                const sourceWebm = document.createElement('source');
                sourceWebm.type = 'video/webm';
                sourceWebm.src = '/wp-content/themes/comparison/assets/video/8Ball_' + category + '.webm';

                const sourceMp4 = document.createElement('source');
                sourceMp4.type = 'video/mp4';
                sourceMp4.src = '/wp-content/themes/comparison/assets/video/8Ball_' + category + '.mp4';

                newVideo.appendChild(sourceWebm);
                newVideo.appendChild(sourceMp4);

                video.parentNode.replaceChild(newVideo, video);

                const oldQuestionsList = document.getElementById('questions_' + this.currentCategory);
                if (oldQuestionsList) {
                    oldQuestionsList.classList.add('hidden');
                }
                const questionsList = document.getElementById('questions_' + category);
                if (questionsList) {
                    questionsList.classList.remove('hidden');
                }

                const oldDescription = document.getElementById('description_' + this.currentCategory);
                if (oldDescription) {
                    oldDescription.classList.add('hidden');
                }
                const description = document.getElementById('description_' + category);
                if (description) {
                    description.classList.remove('hidden');
                }

                this.currentCategory = category;
            });

            const labels = categoryInput.parentElement.getElementsByTagName('label');
            if (labels && labels.length > 0) {
                labels[0].addEventListener('keydown', (event) => {
                    if (event.code === 'Enter') {
                        categoryInput.checked = true;
                        categoryInput.dispatchEvent(new Event('change'));
                    }
                });
            }
        }
    },

    initQuestionForm: function () {
        const form = document.getElementById('question_form');
        if (!form) {
            return;
        }

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.triggerBall();
        });
    },

    initQuestionsClicks: function () {
        const onClick = (event) => {
            event.preventDefault();

            const questionText = event.target.innerHTML;

            const questionInput = document.getElementById('question');
            if (questionInput) {
                questionInput.value = questionText;

                this.triggerBall();
            }
        };

        const questions = document.querySelectorAll('.popular-question a');
        for (const question of questions) {
            question.addEventListener('click', onClick);
        }
    },

    triggerBall: function () {
        if (this.loadingAnswer) {
            return;
        }

        this.hideAnswer();
        this.loadingAnswer = true;

        const video = document.getElementById('ball_video');
        video.currentTime = 0;
        video.play();

        let answer = null;

        setTimeout(() => {
            if (answer) {
                this.showAnswer(answer);
                this.loadingAnswer = false;
            } else {
                this.showAnswer('Loading...');
            }
        }, 6500);

        const data = {};
        data['action'] = 'magic8ball-add-question';

        const formData = new FormData(document.getElementById('question_form'));
        for (const entry of formData) {
            data[entry[0]] = entry[1];
        }

        jQuery.post(ajaxurl, data, (result) => {
            if (result && result.answer) {
                answer = result.answer;
            } else {
                answer = 'Error. Please try later again.'
            }

            if (this.answerShown) {
                this.showAnswer(answer);
                this.loadingAnswer = false;
            }
        }, 'json');
    },

    showAnswer: function (answer) {
        jQuery('#answer').html('<div>' + answer + '</div>').css('display', 'flex');
        this.answerShown = true;
    },

    hideAnswer: function () {
        jQuery('#answer').html('').css('display', 'none');
        this.answerShown = false;
    }
};

jQuery(function ($) {
    Magic8BallPage.init();
});
